import React, {Component} from "react";
import {
  Table,
  Tabs,
  Tab,
  Button
}                         from "react-bootstrap";
import moment             from "moment";
import FileSaver          from "file-saver";

import {
  IS_VALID
}                         from "utils";

export default class View extends Component {
  constructor (props) {
    super(props);

    this.state = {
      isLoading_daily: false,
      isLoading_campaign_period: false,
      isLoading_date_range: false,

      file_data_daily: "",
      file_data_campaign_period: "",
      file_data_date_range: ""
    };
  }

  render () {
    let {
      isLoading_daily,
      isLoading_campaign_period,
      isLoading_date_range,

      file_data_daily,
      file_data_campaign_period,
      file_data_date_range
    } = this.state;

    let {
      EVoucherUpdateLogs
    } = this.props;

    let {
      selectedData
    } = EVoucherUpdateLogs;

    let dateFormat = "MMM DD, YYYY hh:mm:ss A",
        status = "",
        startTime = "",
        endTime = "",
        duration = "",
        server_tdd_startDate = "",
        server_tdd_endDate = "",
        createdAt = "",
        updatedAt = "",
        daily_voucher_log = "",
        campaign_period_voucher_log = "",
        date_range_voucher_log = "";

    if (IS_VALID(selectedData)) {
      if (IS_VALID(selectedData.get("status"))) {
        status = selectedData.get("status");
      }

      if (IS_VALID(selectedData.get("startTime"))) {
        startTime = moment(selectedData.get("startTime")).format(dateFormat);
      }

      if (IS_VALID(selectedData.get("endTime"))) {
        endTime = moment(selectedData.get("endTime")).format(dateFormat);
      }

      if (IS_VALID(selectedData.get("duration"))) {
        duration = `${parseFloat(selectedData.get("duration")).toFixed(3)} minutes`;
      }

      if (IS_VALID(selectedData.get("server_tdd_startDate"))) {
        server_tdd_startDate = moment(selectedData.get("server_tdd_startDate")).format(dateFormat);
      }

      if (IS_VALID(selectedData.get("server_tdd_endDate"))) {
        server_tdd_endDate = moment(selectedData.get("server_tdd_endDate")).format(dateFormat);
      }

      if (IS_VALID(selectedData.get("createdAt"))) {
        createdAt = moment(selectedData.get("createdAt")).format(dateFormat);
      }

      if (IS_VALID(selectedData.get("updatedAt"))) {
        updatedAt = moment(selectedData.get("updatedAt")).format(dateFormat);
      }

      if (IS_VALID(selectedData.get("daily_voucher_log"))) {
        daily_voucher_log = selectedData.get("daily_voucher_log");
      }

      if (IS_VALID(selectedData.get("campaign_period_voucher_log"))) {
        campaign_period_voucher_log = selectedData.get("campaign_period_voucher_log");
      }

      if (IS_VALID(selectedData.get("date_range_voucher_log"))) {
        date_range_voucher_log = selectedData.get("date_range_voucher_log");
      }
    }

    let style = {
      whiteSpace: "pre",
      maxHeight: "40vh",
      marginTop: "10px",
      border: "1px solid #ddd",
      overflowX: "scroll"
    };

    const renderButtons = (text, title = "") => {
      let buttons = "";

      let onView = () => {
        let blob = new Blob([text], { type: "text/plain;charset=utf-8" });

        window.open(URL.createObjectURL(blob));
      };

      let onDownload = () => {
        let blob = new Blob([text], { type: "text/plain;charset=utf-8" });
        FileSaver.saveAs(blob, `${title} - ${startTime}.txt`);
      };

      if (IS_VALID(text)) {
        buttons = [
          <span>
            <Button
              onClick={() => onView()}
              >
              VIEW IN PAGE
            </Button>
            &nbsp;
            <Button
              onClick={() => onDownload()}
              >
              DOWNLOAD <i className="fa fa-download"/>
            </Button>
          </span>,
          <br/>
        ];
      }

      return buttons;
    }

    return (
      <div>
        <Table bordered responsive>
          <tbody>
            <tr>
              <td>
                <b>STATUS</b>
              </td>
              <td>{status}</td>
            </tr>
            <tr>
              <td>
                <b>START</b>
              </td>
              <td>{startTime}</td>
            </tr>
            <tr>
              <td>
                <b>END</b>
              </td>
              <td>{endTime}</td>
            </tr>
            <tr>
              <td>
                <b>DURATION</b>
              </td>
              <td>{duration}</td>
            </tr>
            <tr>
              <td>
                <b>SERVER TDD START</b>
              </td>
              <td>{server_tdd_startDate}</td>
            </tr>
            <tr>
              <td>
                <b>SERVER TDD END</b>
              </td>
              <td>{server_tdd_endDate}</td>
            </tr>
            <tr>
              <td>
                <b>CREATED AT</b>
              </td>
              <td>{createdAt}</td>
            </tr>
            <tr>
              <td>
                <b>UPDATED AT</b>
              </td>
              <td>{updatedAt}</td>
            </tr>
          </tbody>
        </Table>
        <Tabs
          defaultActiveKey={1}
          >
          <Tab
            eventKey={1}
            title="Daily Voucher Logs"
            >
            <br/>
            {renderButtons(file_data_daily, "Daily Voucher Log")}
            <div style={style}>
              {isLoading_daily ? (
                <div style={{ textAlign: "center" }}>
                  <i className="fa fa-spinner fa-spin fa-4x" />
                </div>
              ) : (
                file_data_daily
              )}
            </div>
          </Tab>
          <Tab
            eventKey={2}
            title="Campaign Period Voucher Logs"
            >
            <br/>
            {renderButtons(file_data_campaign_period, "Campaign Period Voucher Log")}
            <br/>
            <div style={style}>
              {isLoading_campaign_period ? (
                <div style={{ textAlign: "center" }}>
                  <i className="fa fa-spinner fa-spin fa-4x" />
                </div>
              ) : (
                file_data_campaign_period
              )}
              </div>
          </Tab>
          <Tab
            eventKey={3}
            title="Date Range Voucher Logs"
            >
            <br/>
            {renderButtons(file_data_date_range, "Date Range Voucher Log")}
            <br/>
            <div style={style}>
             {isLoading_date_range ? (
                <div style={{ textAlign: "center" }}>
                  <i className="fa fa-spinner fa-spin fa-4x" />
                </div>
              ) : (
                file_data_date_range
              )}
            </div>
          </Tab>
        </Tabs>

      </div>
    );
  }

  componentDidMount () {
    let {
      EVoucherUpdateLogs,
      readVoucherUpdateLog
    } = this.props;

    let {
      selectedData
    } = EVoucherUpdateLogs;

    if (IS_VALID(selectedData)) {
      let filename_daily = selectedData.get("filename_daily"),
          filename_campaign_period = selectedData.get("filename_campaign_period"),
           filename_date_range = selectedData.get("filename_date_range");

      if (IS_VALID(filename_daily)) {
        (async () => {
          this.setState({ isLoading_daily: true });

          try {
            let data = await readVoucherUpdateLog(filename_daily);

            this.setState({
              isLoading_daily: false,
              file_data_daily: data
            });
          } catch (error) {
            this.setState({ isLoading_daily: false });
          }
        })();
      }

      if (IS_VALID(filename_campaign_period)) {
        (async () => {
          this.setState({ isLoading_campaign_period: true });

          try {
            let data = await readVoucherUpdateLog(filename_campaign_period);

            this.setState({
              isLoading_campaign_period: false,
              file_data_campaign_period: data
            });
          } catch (error) {
            this.setState({ isLoading_campaign_period: false });
          }
        })();
      }

      if (IS_VALID(filename_date_range)) {
        (async () => {
          this.setState({ isLoading_date_range: true });

          try {
            let data = await readVoucherUpdateLog(filename_date_range);

            this.setState({
              isLoading_date_range: false,
              file_data_date_range: data
            });
          } catch (error) {
            this.setState({ isLoading_date_range: false });
          }
        })();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./components/EVoucherUpdateLogs/FormContainer/View.js